<template>
  <div
    class="refonte-item-participant"
    v-on:click="props.participant.status !== 'deactivated' && props.on_click"
    v-bind:class="`${props.participant.status === 'deactivated' ? 'item-deactivated' : ''} ${props.class}`">
    <div class="item-participant-status">
      <refonte-pastille v-bind:status="props.participant.status" />
    </div>
    <div class="item-participant-infos">
      <div class="item-participant-infos-name">
        {{ props.participant.name }}
      </div>
      <div class="item-participant-infos-email">
        {{ props.participant.email }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import RefontePastille from '@/components/refonte/pastille/refonte-pastille.vue';

  export interface Participant {
    status: string;
    name: string;
    email: string;
  }

  const props = withDefaults(
    defineProps<{
      participant: Participant;
      on_click?: Function;
      class?: string;
    }>(),
    {
      class: ''
    }
  );
</script>

<style lang="scss" scoped>
  .refonte-item-participant {
    @apply flex flex-grow cursor-pointer items-center self-stretch bg-refonte-white;
    gap: 2px;
    padding: 8px;
    border-radius: 8px;

    &:hover {
      @apply bg-refonte-pale-violet-2;
    }

    .item-participant-status {
      @apply flex items-start justify-center self-stretch;
      min-width: 16px;
      width: 16px;
      padding: 4px 0;
    }
    .item-participant-infos {
      @apply flex flex-grow flex-col items-start;
      gap: 2px;

      .item-participant-infos-name {
        @apply self-stretch overflow-hidden text-ellipsis text-refonte-black;
        font-size: 13px;
        font-weight: 400;
        line-height: 125%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }
      .item-participant-infos-email {
        @apply self-stretch text-refonte-black-40;
        font-size: 12px;
        font-weight: 400;
        line-height: 120%;
      }
    }

    &.item-deactivated {
      &:hover {
        @apply cursor-not-allowed bg-refonte-white;
      }

      .item-participant-infos {
        .item-participant-infos-name {
          @apply text-refonte_blue-200;
        }
        .item-participant-infos-email {
          @apply text-refonte_blue-200;
        }
      }
    }
  }
</style>
